document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tabList li");
    const imgBoxes = document.querySelectorAll(".fragranceImgBox .ImgBoxInside");
    const contentBoxes = document.querySelectorAll(".fragranceContent .contentInside");
    const dropdown = document.querySelector(".tabDropdown");

    // CTA BUTTON (target the explore button)
    const ctaBtn = document.querySelector(".exploreCta");

    let activeIndex = 0;
    showTab(activeIndex);

    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function () {
            // Update tab active class
            tabs.forEach((t) => t.classList.remove("tabActive"));
            this.classList.add("tabActive");

            // Show correct tab content
            showTab(index);
        });
    });

    // Dropdown → tab switch
    dropdown.addEventListener("change", function () {
        const index = this.selectedIndex;
        tabs[index].click();
    });

    // Tab → dropdown sync
    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function () {
            dropdown.selectedIndex = index;
        });
    });

    function showTab(index) {
        // Show correct image box
        imgBoxes.forEach((box, i) => {
            box.classList.toggle("active", i === index);
        });

        // Show correct content box
        contentBoxes.forEach((box, i) => {
            box.classList.toggle("active", i === index);
        });

        // Init Swiper for the active image set
        const swiperEl = imgBoxes[index].querySelector(".fragrance_swiper");

        if (swiperEl && !swiperEl.swiper) {
            const swiper = new Swiper(swiperEl, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,
                speed: 1000,
                effect: "slide",
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: imgBoxes[index].querySelector(".fragrance_pagination"),
                    clickable: true,
                    // renderBullet: function (i, className) {
                    //     return `<span class="${className}">0${i + 1}</span>`;
                    // },
                },
            });

            // 🔥 Update CTA link on initial load
            updateCtaFromActiveSlide(swiper);

            // 🔥 Update CTA every time slide changes
            swiper.on("slideChange", function () {
                updateCtaFromActiveSlide(swiper);
            });
        } else if (swiperEl && swiperEl.swiper) {
            // If already initialized, update CTA for current slide
            updateCtaFromActiveSlide(swiperEl.swiper);
        }
    }

    // 🔥 Function: Update CTA href based on active slide's data-url
    function updateCtaFromActiveSlide(swiper) {
        if (!ctaBtn) return;

        const activeSlide = swiper.slides[swiper.activeIndex];
        const newUrl = activeSlide.getAttribute("data-url");

        if (newUrl) {
            ctaBtn.setAttribute("href", newUrl);
        }
    }
});
